import React, { createContext, useEffect, useState } from 'react'

import { getNotificationCount } from '@/apis/notifications'

export type NotificationContextProps = [count: number, setNotificationCount: (count: number) => void]

export const NotificationContext = createContext<NotificationContextProps>([
  0,
  () => {
    // Do nothing
  },
])

const NotificationContextProvider: React.FC = ({ children }) => {
  const [count, setCount] = useState<number>(0)

  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const res = await getNotificationCount()
        setCount(res)
      } catch (err) {}
    }

    fetchNotificationCount()
  }, [])

  const setNotificationCount = (count: number) => {
    setCount(count)
  }

  return <NotificationContext.Provider value={[count, setNotificationCount]}>{children}</NotificationContext.Provider>
}

NotificationContextProvider.displayName = 'NotificationContextProvider'
export default NotificationContextProvider
